import type { Settings, ThemeType } from '@n3/pn-declaration';
import { API } from '@/constants/api';

export { components } from './components';

export const theme: ThemeType = {
  breakpoints: {
    mobile: 320,
    tablet: 768,
    desktop: 1180,
  },

  colors: {
    gradient: '#4a90e2',
    primary: '#4a90e2',
    primaryLight: '#CDD4DE',
    secondary: '#F4B840',
    white: '#fff',
    dark: '#2D323A',
    gray: '#686868',
    middleGray: '#BABABA',
    lightGray: '#F2F1F1',
    error: '#FF4677',
    success: '#008B10',
  },

  fontFamily: 'Rubik, Open Sans, sans-serif',

  fontSources: {
    h1: (fontFamily, conditions) => ({
      fontFamily,
      fontWeight: 500,
      fontSize: 28,
      lineHeight: 1.1875,

      [conditions.tablet]: {
        fontSize: 32,
      },
    }),

    h2: (fontFamily, conditions) => ({
      fontFamily,
      fontWeight: 500,
      fontSize: 24,
      lineHeight: 1.3333,

      [conditions.tablet]: {
        fontSize: 24,
      },
    }),

    h3: (fontFamily, conditions) => ({
      fontFamily,
      fontWeight: 500,
      fontSize: 16,
      lineHeight: 1.2777,

      [conditions.tablet]: {
        fontSize: 18,
      },
    }),

    h4: (fontFamily, conditions) => ({
      fontFamily,
      fontWeight: 500,
      fontSize: 14,
      lineHeight: 1.375,

      [conditions.tablet]: {
        fontSize: 16,
      },
    }),

    caption: (fontFamily) => ({
      fontFamily,
      fontWeight: 400,
      fontSize: 12,
      lineHeight: 1.5,
    }),

    body: (fontFamily) => ({
      fontFamily,
      fontWeight: 400,
      fontSize: 14,
      lineHeight: 1.375,
    }),
  },

  distances: {
    fieldHeightDefault: 42,
    fieldHeightSmall: 32,
    fieldBorderRadius: 4,
    fieldIconWidth: 44,
    tooltipBorderRadius: 4,
    tooltipMaxWidth: 350,
    tooltipPadding: '10px 20px',
    tooltipVerticalOffset: 10,
  },
};

export const settings: Partial<Settings> = {
  header: {
    logoDesktop: '/img/logo.svg',
    logoMobile: '/img/logo.svg',
    logoTitle: 'Современное образование Ленинградской области',
  },
  auth: {
    loginUrl: '/monitoring-api/authenticate/init/',
    logoutUrl: `/monitoring-api/authenticate/logout/?success_redirect_url=${API.EIOPUrl}api/auth/logout/`,
  },
};
